
export default {
  name: 'QuickViewActionButton',
  methods: {
    newNote () {
      this.close()
      this.$nextTick(() => {
        this.$store.commit('setQuickview', {mode: 'NEW_NOTE'})
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/quickview/QuickViewActionButton.js